import util from './util';
export default class Observer {
    constructor() {
        this.listeners = {};
        this.params = {};
    }
    dispatch(eventName, params) {
        params = util.deepClone(params);
        const listeners = this.listeners[eventName] || [];
        if (!this.params[eventName]) {
            this.params[eventName] = [];
        }
        this.params[eventName].push(params);
        listeners.forEach(listener => {
            listener(params);
        });
    }
    subject(eventName, fn) {
        if (typeof fn !== 'function') {
            throw new TypeError('fn should be a function');
        }
        if (!this.listeners[eventName]) {
            this.listeners[eventName] = [];
        }
        this.listeners[eventName].push(fn);
        return () => {
            const index = this.listeners[eventName].indexOf(fn);
            this.listeners[eventName].splice(index, 1);
        };
    }
    last(eventName, fn) {
        const params = this.params[eventName] || [];
        if (params.length) {
            fn(params[params.length - 1]);
        }
        return this.subject(eventName, fn);
    }
    all(eventName, fn) {
        const params = this.params[eventName] || [];
        params.forEach(data => fn(data));
        return this.subject(eventName, fn);
    }
}
